import { Input, Button } from "@/components/ui";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Form } from "@/components/ui/form";
import { useForgotPassword } from "@/api/mutation";
import { ForgotPasswordDTO } from "@/api/types";

const forgotPasswordSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
});

export const ForgotPassword = () => {
  const form = useForm({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: "",
    },
  });

  const { mutate, isPending } = useForgotPassword();

  const onSubmit = async (credentials: ForgotPasswordDTO) => {
    try {
      console.log("Submitting email:", credentials.email);
      mutate(credentials, {
        onSuccess: () => {
          localStorage.setItem("pendingVerificationEmail", credentials.email);
        },
      });
    } catch (error) {
      console.error("Forgot password error:", error);
    }
  };

  return (
    <div className='grid gap-6'>
      <header className='space-y-px'>
        <h3>Reset your password</h3>
        <p className='text-muted-foreground text-sm'>
          A reset password link will be sent to your email.
        </p>
      </header>
      <Form.Root {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className='grid gap-4' noValidate>
          <Form.Field
            control={form.control}
            name='email'
            render={({ field }) => (
              <Form.Item>
                <Form.Label>Email</Form.Label>
                <Form.Control>
                  <Input placeholder='name@domain.com' {...field} />
                </Form.Control>
                <Form.Message />
              </Form.Item>
            )}
          />
          <div className='flex flex-col gap-3'>
            <Button type='submit' size='lg' className='w-full' loading={isPending}>
              Send reset email
            </Button>
          </div>
        </form>
      </Form.Root>
      <div className='text-center text-sm'>
        <p>
          Remember your password? <Link to='/login'>Sign in</Link>
        </p>
      </div>
    </div>
  );
};
